import { Alignment } from 'domain/constants/alignment';
import { css, cx } from 'linaria';
import { cssTheme } from '@uds/theme-utils';

const subtitle = css`
  margin-top: ${cssTheme.gu2};
`;

const root = {
  default: css`
    text-align: left;
    display: block;
    width: 100%;
  `,
  centered: css`
    text-align: center;
  `,
};

const cta = {
  default: css`
    margin-top: ${cssTheme.gu1};
    &&& {
      ${cssTheme.breakpoints.sm} {
        margin-right: ${cssTheme.gu2};
      }
    }
  `,
};
const ctas = {
  default: css`
    margin-top: ${cssTheme.gu2};
    overflow: hidden;
    &&& {
      ${cssTheme.breakpoints.sm} {
        display: flex;
      }
    }
  `,
  centered: css`
    justify-content: center;
  `,
};

export default ({ alignment }: { alignment: Alignment }) => {
  return {
    root: cx(root.default, alignment === Alignment.CENTER && root.centered),
    cta: cta.default,
    ctas: cx(ctas.default, alignment === Alignment.CENTER && ctas.centered),
    subtitle,
  };
};
